export default["__VITE_ASSET__JIY4eLQq__","__VITE_ASSET__7TFknFeF__"];